import React from "react";
import { Row, Col, Button, Space, Typography, Grid } from "antd";
import { Link } from "react-router-dom";

const { Text } = Typography;
const { useBreakpoint } = Grid;

const CartSummary = ({ totalItems, totalPrice, handleBuyNow }) => {
  const screens = useBreakpoint();

  return (
    <Row
      justify="space-between"
      align="middle"
      gutter={[16, 16]}
      style={{
        marginTop: "16px",
        padding: screens.xs ? "12px 8px" : "16px 0",
        borderTop: "1px solid #f0f0f0",
      }}
    >
      {/* Total Info */}
      <Col xs={24} sm={14} md={16}>
        <Space
          direction={screens.xs ? "horizontal" : "horizontal"}
          size={screens.xs ? "middle" : "large"}
          wrap
          style={{
            width: "100%",
            justifyContent: screens.xs ? "space-between" : "flex-start",
          }}
        >
          <Text style={{ fontSize: screens.xs ? "14px" : "15px" }}>
            Total Items: <Text strong>{totalItems}</Text>
          </Text>
          <Text style={{ fontSize: screens.xs ? "14px" : "15px" }}>
            Total Price:{" "}
            <Text
              strong
              type="danger"
              style={{ fontSize: screens.xs ? "16px" : "18px" }}
            >
              ${totalPrice}
            </Text>
          </Text>
        </Space>
      </Col>

      {/* Buy Now Action */}
      <Col
        xs={24}
        sm={10}
        md={8}
        style={{ textAlign: screens.xs ? "stretch" : "right" }}
      >
        <Link
          to="/cart/checkout"
          state={{ selectedItems: handleBuyNow }}
          style={{
            width: screens.xs ? "100%" : "auto",
            display: "inline-block",
          }}
        >
          <Button
            type="primary"
            size={screens.xs ? "large" : "middle"}
            block={screens.xs} // Full width button on mobile
            disabled={totalItems === 0}
          >
            Buy Now
          </Button>
        </Link>
      </Col>
    </Row>
  );
};

export default CartSummary;
